<template>
  <div
    class="calc-nav-mobile"
    :class="{'calc-nav-mobile_with-error': errorText }"
  >
    <slot name="content">
      <div class="calc-nav-mobile__content">
        <CalcCommentError
          v-if="errorText"
          class="calc-nav-mobile__error"
        >
          {{ errorText }}
        </CalcCommentError>
        <div class="calc-nav-mobile__btn-wrap">
          <a
            class="calculator__button calculator__button_back-step"
            @click.prevent="$emit('step-back')"
          >
            <svg
              class="arrow-icon"
              width="24px"
              height="24px"
            >
              <use xlink:href="#arrow-down" />
            </svg>
          </a>
          <a
            class="calculator__button calculator__button_red calculator__button_next-step"
            :class="{'calculator__button_loading': isLoading}"
            @click.prevent="$emit('stepValidation')"
          >
            <slot name="btnNext">
              <svg
                class="arrow-icon"
                width="24px"
                height="24px"
              >
                <use xlink:href="#arrow-down" />
              </svg>
              {{ $t('calc.btn.dalee') }}
            </slot>
          </a>
        </div>
      </div>
    </slot>
  </div>
</template>

<script>
import CalcCommentError from './CalcCommentError.vue';

export default {
  name: 'CalcNavMobile',
  components: { CalcCommentError },
  props: ['isLoading', 'errorText'],
};
</script>

<style lang="scss" scoped>
.calc-nav-mobile {
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 73px;
  padding: 16px;
  border-radius: 20px 20px 0 0;
  box-shadow: 0px -4px 15px 0px #33333326;
  background: #FFFFFF;
  z-index: 99998;
  transition: height .3s;
  &_with-error {
    height: auto;
  }
}
.calculator__button.calculator__button_back-step {
  padding-left: 5px !important;
  padding-right: 5px !important;
  width: 40px !important;
  min-width: 40px !important;
  svg {
    flex-shrink: 0;
    margin: 0 !important;
  }
}
.calculator__button_next-step {
  svg {
    margin-right: 0;
  }
}
.calc-nav-mobile__content {
  width: 100%;
}
.calc-nav-mobile__btn-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.calc-nav-mobile__error {
  margin-bottom: 16px;
}
</style>
